import { create } from 'zustand';

export type TaskDrawerScope = {
  /** When set, the drawer filters tasks to this itinerary. */
  itineraryId?: string;
  /**
   * When set, the drawer filters to this account. Defaults inside the
   * drawer body (when both this and itineraryId are absent) to the
   * current user's incomplete tasks.
   */
  assignedAccountId?: string;
};

type TaskDrawerState = {
  open: boolean;
  scope: TaskDrawerScope;
  openDrawer: (scope?: TaskDrawerScope) => void;
  closeDrawer: () => void;
};

/**
 * Cross-page overlay state for the task drawer. The drawer trigger lives
 * in the global topbar AND on the itinerary detail page; both call into
 * this single store so opening from either site (or programmatically) is
 * uniform. Filters never travel through the URL — the URL belongs to the
 * page underneath the drawer.
 */
export const useTaskDrawerStore = create<TaskDrawerState>()((set) => ({
  open: false,
  scope: {},
  openDrawer: (scope = {}) => set({ open: true, scope }),
  closeDrawer: () => set({ open: false }),
}));
